import { pipe } from "fp-ts/function";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { IconSet, IconSetsV, IconSetUnawareIcon, IconV } from "@/types/icons";
import { fold } from "fp-ts/Either";
import { array, unknown } from "io-ts";

export async function findIcons(params: {
  iconSetSlug?: string | null;
  searchTerm?: string | null;
  offset?: number | null;
  suggestions?: string[] | null;
}) {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_find_icons",
      decoder: array(IconV),
      dataToPost: params
    }),
    fold(
      () => null,
      icons => icons
    )
  );
}

export async function getIconSets() {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_get_icon_sets",
      decoder: IconSetsV
    }),
    fold(
      () => null,
      data => data
    )
  );
}

export async function deleteIconSet(iconSetSlug: IconSet["slug"]) {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_delete_icon_set",
      decoder: unknown,
      dataToPost: {
        iconSetSlug
      }
    }),
    fold(
      () => false,
      () => true
    )
  );
}

export async function uploadIcons(
  icons: IconSetUnawareIcon[],
  iconSet: IconSet
) {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_upload_icons",
      decoder: unknown,
      dataToPost: {
        icons,
        iconSet
      }
    }),
    fold(
      () => false,
      () => true
    )
  );
}
